import {
  studentConstants
} from "../_constants";
import {
  studentService
} from "../_services";
export const studentActions = {
  login,
  logout
};

function login(number, birthDate, studentType, password) {
  return dispatch => {
    dispatch(request({
      number,
      birthDate,
      studentType,
      password
    }));

    studentService.login(number, birthDate, studentType, password).then(
      student => {
        dispatch(success(student));
      },
      error => {
        dispatch(failure(error));
      }
    );
  };

  function request(number, birthDate, studentType, password) {
    return {
      type: studentConstants.STUDENT_LOGIN_REQUEST,
      payload: {
        number,
        birthDate,
        studentType,
        password
      }
    };
  }

  function success(student) {
    return {
      type: studentConstants.STUDENT_LOGIN_SUCCESS,
      student
    };
  }

  function failure(error) {
    return {
      type: studentConstants.STUDENT_LOGIN_FAILURE,
      error
    };
  }
}

function logout() {
  studentService.logout();
  return {
    type: studentConstants.STUDENT_LOGOUT
  };
}